module.exports = __webpack_public_path__ + "img/blue-ticket-details.50fb5877.svg";